<template>
  <div id="add-new-order-modal">
    <v-layout
      row
      justify-center
    >
      <v-dialog
        v-model="partialRefundOrderModal"
        persistent
        max-width="530px"
      >
        <v-card>
          <form
            action=""
            @submit.prevent="submitForm()"
          >
            <v-card-title>
              <v-flex
                xs11
                sm11
                md11
              ><span class="headline">Partial Refund</span></v-flex>
              <v-flex
                xs1
                sm1
                md1
              >
                <v-btn
                  flat
                  @click="closePartialRefundOrderModal(), $validator.reset()"
                  class="close"
                ><span aria-hidden="true">
              <i class="material-icons" style="font-size: 24px;vertical-align: middle;">close</i>
            </span></v-btn>
              </v-flex>
            </v-card-title>
            <v-card-text>
              <v-alert
                type="success"
                :value="checkAlert"
              >
                Done successfully
              </v-alert>
              <v-layout wrap>
                <v-flex sm12>
                  <v-text-field
                    label="Amount*"
                    v-model="partialRefundData.amount"
                    :error-messages="errors.collect('Amount')"
                    v-validate="'required|decimal:2|between:0.1,' + (theOrderTotalAmount)"
                    data-vv-name="Amount"
                  ></v-text-field>
                </v-flex>

                <v-flex sm12>
                  <v-text-field
                    label="Note"
                    v-model="partialRefundData.note"
                  ></v-text-field>
                </v-flex>

                <v-flex
                  sm7
                  md7
                >
                  <h6>
                    <span style="color: red">*</span> The order Total amount is ${{theOrderTotalAmount }}
                  </h6>
                </v-flex>

                <v-flex
                  v-if="partialRefundData.partial_refunds && partialRefundData.partial_refunds.length > 0"
                  xs12
                >
                  <h6>Partial Refunds</h6>
                  <ol>
                    <li
                      v-for="(obj, index) in partialRefundData.partial_refunds"
                      :key="index"
                      style="font-size: 14px"
                    >
                      Amount ${{ obj.amount }} <span class="px-2">at {{ obj.created_at | moment('YYYY-MM-DD hh:mm A') }}</span> by {{ obj.user.full_name }}
                    </li>
                  </ol>
                </v-flex>

                <v-flex
                  v-if="partialRefundData.partial_refunds && partialRefundData.partial_refunds.length > 0"
                  sm12
                >
                  <h5>Order Total remain amount is ${{orderRemainAmount}}</h5>
                </v-flex>
              </v-layout>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn
                style="height:auto"
                @click="closePartialRefundOrderModal(), $validator.reset()"
                outline
                color="normal"
              >Cancel</v-btn>
              <v-btn
                type="submit"
                :loading="loading"
                style="height:auto; margin-right: 4%"
                outline
                color="success"
              >Save</v-btn>
            </v-card-actions>
          </form>
        </v-card>
      </v-dialog>
    </v-layout>
  </div>
</template>
<script>
export default {
  props: [
    'partialRefundOrderModal',
    'closePartialRefundOrderModal',
    'checkAlert',
    'partialRefundData',
    'partialRefundOrder',
    'loading',
    'theOrderTotalAmount'
  ],

  data() {
    return {
      loggedInUserData: {}
    }
  },

  computed: {
    orderRemainAmount() {
      if (this.partialRefundData.partial_refunds && this.partialRefundData.partial_refunds.length > 0) {
        let reAmount = 0
        this.partialRefundData.partial_refunds.forEach(x => {
          reAmount += Number(x.amount)
        })

        let amount = this.theOrderTotalAmount - reAmount
        return amount.toFixed(2)
      }

      return this.theOrderTotalAmount.toFixed(2)
    }
  },

  mounted() {
    this.getLoggedInUser()
  },

  methods: {
    getLoggedInUser() {
      this.loggedInUserData = JSON.parse(localStorage.getItem('user_data'))
    },

    submitForm() {
      this.$validator.validateAll().then(res => {
        if (res) {
          this.partialRefundOrder()
        }
      })
    }
  }
}
</script>

<style>
.overlay--active:before {
  opacity: 50 !important;
  background: rgba(0, 0, 0, 0.5) !important;
}
</style>



// WEBPACK FOOTER //
// src/components/partialRefundingOrder.vue